/**
 * Brand Logos Script - NovusProtect.ro
 * Versiune FINALĂ cu logo PNG Ardon
 * Pentru tema Dawn 15.4.1
 */

(function() {
  'use strict';

  // Maparea brandurilor cu URL-urile logourilor (normalizat lowercase)
  const brandLogos = {
    'portwest': 'https://d11ak7fd9ypfb7.cloudfront.net/com_images/sitewide/portwest-logo-oj.png?2',
    
    
    'ardon': 'https://cdn.shopify.com/s/files/1/1017/3127/0987/files/ARDON-logo_0x200_ee7a8eeb-c38f-4e5d-a1d3-a907fe1bdcf3.png?v=1770379177'

  };

  // Cache pentru elemente deja procesate
  const processedElements = new WeakSet();

  /**
   * Creează elementul de logo
   */
  function createLogoElement(brandName, logoUrl, altText) {
    const img = document.createElement('img');
    img.src = logoUrl;
    img.alt = altText || `Logo ${brandName}`;
    img.className = 'brand-logo';
    img.loading = 'lazy';
    
    // Adaugă clasa loaded după încărcare
    img.addEventListener('load', function() {
      img.classList.add('loaded');
    });
    
    // Fallback pentru erori
    img.addEventListener('error', function() {
      console.warn('❌ NovusProtect: Logo-ul nu s-a încărcat pentru', brandName);
      // Afișează textul original dacă logo-ul nu se încarcă
      img.parentElement.textContent = brandName;
    });
    
    return img;
  }

  /**
   * Obține logo-ul pentru un brand (case-insensitive)
   */
  function getLogoForBrand(brandName) {
    if (!brandName) return null;
    
    const cleanBrandName = brandName.trim().toLowerCase();
    return brandLogos[cleanBrandName] || null;
  }

  /**
   * Înlocuiește vendor-ul pe pagina de produs
   */
  function replaceProductVendor() {
    const vendorSelectors = [
      '.product__text.caption-with-letter-spacing',
      '.product__info-container .caption-with-letter-spacing',
      'a[href*="/collections/vendors"]',
      '.product-info .vendor',
      '.product__vendor'
    ];

    let replaced = false;

    vendorSelectors.forEach(selector => {
      const vendorElements = document.querySelectorAll(selector);
      
      vendorElements.forEach(element => {
        if (processedElements.has(element)) {
          return;
        }

        const vendorText = element.textContent.trim();
        const logoUrl = getLogoForBrand(vendorText);
        
        if (logoUrl) {
          const logo = createLogoElement(vendorText, logoUrl, `Logo ${vendorText}`);
          
          processedElements.add(element);
          element.classList.add('brand-logo-processed');
          
          element.innerHTML = '';
          element.appendChild(logo);
          
          if (element.tagName === 'A') {
            element.style.display = 'inline-block';
          }
          
          replaced = true;
          console.log('✅ NovusProtect: Logo înlocuit pentru', vendorText);
        }
      });
    });

    return replaced;
  }

  /**
   * Înlocuiește titlul colecției cu logo
   */
  function replaceCollectionTitle() {
    const collectionTitleSelectors = [
      '.collection-hero__title',
      '.page-header .title',
      '.collection__title',
      'h1.title.title--primary'
    ];

    collectionTitleSelectors.forEach(selector => {
      const titleElements = document.querySelectorAll(selector);
      
      titleElements.forEach(element => {
        if (processedElements.has(element)) {
          return;
        }

        const titleText = element.textContent.trim();
        const logoUrl = getLogoForBrand(titleText);
        
        if (logoUrl) {
          const logo = createLogoElement(titleText, logoUrl, `Colecție ${titleText}`);
          
          processedElements.add(element);
          element.classList.add('brand-logo-processed');
          element.innerHTML = '';
          element.appendChild(logo);
          
          console.log('✅ NovusProtect: Logo colecție înlocuit pentru', titleText);
        }
      });
    });
  }

  /**
   * Actualizează logo-urile în breadcrumbs
   */
  function updateBreadcrumbs() {
    const breadcrumbLinks = document.querySelectorAll('.breadcrumbs a, .breadcrumb a');
    
    breadcrumbLinks.forEach(link => {
      if (processedElements.has(link)) {
        return;
      }

      const linkText = link.textContent.trim();
      const logoUrl = getLogoForBrand(linkText);
      
      if (logoUrl) {
        const logo = createLogoElement(linkText, logoUrl, linkText);
        
        processedElements.add(link);
        link.classList.add('brand-logo-processed');
        link.innerHTML = '';
        link.appendChild(logo);
      }
    });
  }

  /**
   * Inițializează toate înlocuirile
   */
  function initBrandLogos() {
    replaceProductVendor();
    replaceCollectionTitle();
    updateBreadcrumbs();
  }

  /**
   * Observer pentru conținut dinamic
   */
  function observeDynamicContent() {
    let timeoutId;
    
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(initBrandLogos, 150);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Inițializare
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initBrandLogos();
      observeDynamicContent();
    });
  } else {
    initBrandLogos();
    observeDynamicContent();
  }

  window.addEventListener('load', initBrandLogos);

  // API public pentru adăugarea altor branduri
  window.novusProtectBrandLogos = {
    init: initBrandLogos,
    addBrand: function(brandName, logoUrl) {
      brandLogos[brandName.toLowerCase()] = logoUrl;
      initBrandLogos();
      console.log('✅ Brand adăugat:', brandName);
    },
    getBrands: function() {
      return Object.keys(brandLogos);
    }
  };

  console.log('✅ NovusProtect Brand Logos: Script încărcat cu succes!');
  console.log('📦 Branduri disponibile:', Object.keys(brandLogos).join(', '));

})();
